import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";

import "leaflet/dist/leaflet.css";
import { Remove } from "@mui/icons-material";

import { MapContainer, TileLayer, Marker, useMapEvents, Popup } from "react-leaflet";
import L from "leaflet";
import marcador from "../../../images/uvic.png";
import { useMap } from "react-leaflet";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	TextField,
	Select,
	MenuItem,
	FormControl,
} from "@mui/material";
import maps_rojo from "../../../images/maps_rojos.png";
import ubicaction_exacta from "../../../images/ubicacion-exacta-jhimbo.png";
import ubicacion_jhimbop from "../../../images/ubicacion-jhimbo.png";
import { ApiService, SelectBranchs, useProveedorCompany, returnFullURL } from '../../../components';
import LocationIcon from "../../../svg/LocationIcon";

const DAYS = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];

function MapClickHandler({ onMapClick }) {
	useMapEvents({
		click: (e) => {
			onMapClick(e.latlng);
		},
	});
	return null; // no renderiza nada
}

function ChangeMapView({ coords }) {
	const map = useMap();
	useEffect(() => {
		map.setView(coords);
	}, [coords, map]);
	return null;
}

export const VisitasUbicacionEdit = ({ view3 }) => {
	const { currentBranch, setCurrentBranch, currentCompany, setArrayBranchs } = useProveedorCompany();
	const company_name = currentCompany?.nameComany;

	const {
		locality_text: localizacion = "Información del local",
		day_ini: dia_inicio = "Lunes",
		day_Fin: dia_Fin = "Lunes",
		time_range: rango_hora = "Sin Definir",
		particular_day: particular_dia = "Lunes",
		particular_time: particular_hora = "Sin Definir",
		lat: latitud = "-17.7812221",
		lon: longitud = "-63.1797761",
	} = currentBranch ?? {};

	// --- STATES ---
	// 1) Texto "HORARIO DE ATENCIÓN" - se edita en línea
	const [titleAttention, setTitleAttention] = useState("HORARIO DE ATENCIÓN");
	const [isEditingTitle, setIsEditingTitle] = useState(false);
	const [tempTitle, setTempTitle] = useState(titleAttention);

	// 2) Rango de días "Lunes a Viernes" - se edita con modal y dos Select;
	const [showDaysModal, setShowDaysModal] = useState(false);

	// Estados temporales para el modal
	const [tempDaysRangeStart, setTempDaysRangeStart] = useState(dia_inicio);
	const [tempDaysRangeEnd, setTempDaysRangeEnd] = useState(dia_Fin);

	// 3) Horario "8:00am - 18:00pm" (Lunes-Viernes) - se edita con un modal (TextField)
	const [tempWeekSchedule, setTempWeekSchedule] = useState(rango_hora);
	const [showWeekScheduleModal, setShowWeekScheduleModal] = useState(false);

	// 4) Texto "Sábados" - edición en línea
	const [tempSaturdayText, setTempSaturdayText] = useState(particular_dia);
	const [isEditingSaturday, setIsEditingSaturday] = useState(false);

	// 5) Horario "8:00am - 16:00pm" (Sábados) - modal
	const [tempSaturdaySchedule, setTempSaturdaySchedule] = useState(particular_hora);
	const [showSaturdayScheduleModal, setShowSaturdayScheduleModal] = useState(false);

	const [openMapModal, setOpenMapModal] = useState(false);

	const [tempLat, setTempLat] = useState(latitud);
	const [tempLng, setTempLng] = useState(longitud);
	const customIcon = new L.Icon({
		iconUrl: marcador,
		iconSize: [32, 32], // o ajusta a lo que necesites
		iconAnchor: [16, 32], // punto de anclaje en el ícono
		popupAnchor: [0, -32], // punto donde aparece el popup
	});

	// --- VALIDACIONES ---

	// Validar rango de días (no permitir que el inicio sea > fin)
	const validateDayRange = (start, end) => {
		const startIndex = DAYS.indexOf(start);
		const endIndex = DAYS.indexOf(end);
		// Si no encontró el día o el rango está invertido => inválido
		if (startIndex === -1 || endIndex === -1) return false;
		return startIndex <= endIndex;
	};

	// Validar formato de horario, algo muy simple: "8:00am - 18:00pm"
	const validateScheduleFormat = (value) => {
		// Regex que detecta "hh:mm(am|pm) - hh:mm(am|pm)"
		const pattern = /^(\d{1,2}:\d{2}(am|pm))\s*-\s*(\d{1,2}:\d{2}(am|pm))$/i;
		return pattern.test(value);
	};

	// --- HANDLERS PARA EDICIÓN EN LÍNEA ---

	// 1) "HORARIO DE ATENCIÓN"
	const handleTitleClick = () => {
		setTempTitle(titleAttention);
		setIsEditingTitle(true);
	};
	const handleSaveTitle = () => {
		if (!tempTitle.trim()) {
			toast.error("El título no puede quedar vacío.");
			return;
		}
		setTitleAttention(tempTitle);
		setIsEditingTitle(false);
		toast.success("Título actualizado.");
	};
	const handleCancelTitle = () => {
		setIsEditingTitle(false);
		setTempTitle(titleAttention);
	};

	// 4) "Sábados" (texto)
	const handleSaturdayClick = () => {
		setTempSaturdayText(particular_dia);
		setIsEditingSaturday(true);
	};
	const handleSaveSaturdayText = async () => {
		if (!tempSaturdayText.trim()) {
			toast.error("El texto no puede quedar vacío.");
			return;
		}

		const updateDaysIni = await updateDataBranch({
			particular_day: tempSaturdayText,
		});

		if (updateDaysIni) {
			setIsEditingSaturday(false);

			const branch_updated = {
				...currentBranch,
				particular_day: tempSaturdayText,
			};

			updateStateBranchs(branch_updated);
			toast.success("Texto actualizado.");
		}
	};
	const handleCancelSaturdayText = () => {
		setIsEditingSaturday(false);
		setTempSaturdayText(particular_dia);
	};

	// --- HANDLERS PARA MODALS ---

	// 2) Rango de días (Lunes a Viernes)
	const openDaysModal = () => {
		setTempDaysRangeStart(dia_inicio);
		setTempDaysRangeEnd(dia_Fin);
		setShowDaysModal(true);
	};
	const handleSaveDays = async () => {
		if (!validateDayRange(tempDaysRangeStart, tempDaysRangeEnd)) {
			toast.error("Rango de días inválido.");
			return;
		}

		const updateDaysIni = await updateDataBranch({
			day_ini: tempDaysRangeStart,
			day_Fin: tempDaysRangeEnd,
		});

		if (updateDaysIni) {
			setShowDaysModal(false);

			const branch_updated = {
				...currentBranch,
				day_ini: tempDaysRangeStart,
				day_Fin: tempDaysRangeEnd,
			};

			updateStateBranchs(branch_updated);
			toast.success("Días actualizados.");
		}
	};
	const handleCancelDays = () => {
		setShowDaysModal(false);
		setTempDaysRangeStart(dia_inicio);
		setTempDaysRangeEnd(dia_Fin);
	};

	// 3) Horario "8:00am - 18:00pm"
	const openWeekScheduleModal = () => {
		setTempWeekSchedule(rango_hora);
		setShowWeekScheduleModal(true);
	};
	const handleSaveWeekSchedule = async () => {
		if (!validateScheduleFormat(tempWeekSchedule)) {
			toast.error("Formato de horario inválido. Ej: 8:00am - 18:00pm");
			return;
		}

		const updateDaysIni = await updateDataBranch({
			time_range: tempWeekSchedule,
		});

		if (updateDaysIni) {
			setShowWeekScheduleModal(false);

			const branch_updated = {
				...currentBranch,
				time_range: tempWeekSchedule,
			};

			updateStateBranchs(branch_updated);

			toast.success("Horario actualizado.");
		}
	};
	const handleCancelWeekSchedule = () => {
		setShowWeekScheduleModal(false);
		setTempWeekSchedule(rango_hora);
	};

	// 5) Horario "8:00am - 16:00pm" (Sábados)
	const openSaturdayScheduleModal = () => {
		setTempSaturdaySchedule(particular_hora);
		setShowSaturdayScheduleModal(true);
	};
	const handleSaveSaturdaySchedule = async () => {
		if (!validateScheduleFormat(tempSaturdaySchedule)) {
			toast.error("Formato de horario inválido. Ej: 8:00am - 16:00pm");
			return;
		}

		const updateDaysIni = await updateDataBranch({
			particular_time: tempSaturdaySchedule,
		});

		if (updateDaysIni) {
			setShowSaturdayScheduleModal(false);

			const branch_updated = {
				...currentBranch,
				particular_time: tempSaturdaySchedule,
			};

			updateStateBranchs(branch_updated);
			toast.success("Horario actualizado.");
		}
	};
	const handleCancelSaturdaySchedule = () => {
		setTempSaturdaySchedule(particular_hora);
		setShowSaturdayScheduleModal(false);
	};

	async function updateDataBranch(requestBody = {}) {
		const fetch_update = await ApiService.fetchData(`api/company/update/us?key_branch=${currentBranch?.key_branch}`, {
			method: "PUT",
			body: JSON.stringify(requestBody),
		});

		if (fetch_update) {
			toast.success(fetch_update?.message ?? "Datos actualizados correctamente");
		} else {
			toast.error("Error al actualizar los datos.");
		}

		return fetch_update?.code === 200;
	}

	async function updateCoodenadas(event) {
		event.preventDefault();
		const latNum = parseFloat(tempLat);
		const lngNum = parseFloat(tempLng);
		if (isNaN(latNum) || isNaN(lngNum)) {
			toast.error("Lat/Lng inválidos");
			return;
		}

		const updateCoordinates = await updateDataBranch({
			lat: String(latNum),
			lon: String(lngNum),
		});

		if (updateCoordinates) {
			setOpenMapModal(false);

			const branch_updated = {
				...currentBranch,
				lat: latNum,
				lon: lngNum,
			};

			updateStateBranchs(branch_updated);
			toast.success("Ubicación actualizada");
		}
	}

	function updateStateBranchs(branch_updated) {
		setCurrentBranch(branch_updated);

		setArrayBranchs((current_list) => {
			let position = -1;

			for (let i = 0; i < (current_list ?? []).length; i++) {
				const obj = current_list[i];
				if (obj?.key_branch === currentBranch?.key_branch) {
					position = i;
					break;
				}
			}

			if (position >= 0) {
				return [
					...current_list.slice(0, position),
					branch_updated,
					...current_list.slice(position + 1),
				];
			} else {
				return current_list;
			}
		});
	}

	const validateDays = (value) => {
		let format_text = String(value).toLowerCase();
		format_text = format_text.charAt(0).toUpperCase() + format_text.slice(1).toLowerCase();
		const newValue = {
			'Miercoles': 'Miércoles',
			'Sabado': 'Sábado'
		};

		return newValue[format_text] ?? format_text;
	}
	return (
		<>
			<div className='our-ubication'>
				<div className='title-jhimbo-content'>
					<div className='title-ubication-jhimbo'>
						<div className='back-jhimbo'><h3 style={{ color: 'var(--theme-company)' }}>{company_name ?? "Dato invalido"}</h3></div>
						<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
							<Remove fontSize="large" />

							<SelectBranchs color={'var(--theme-main)'} />
						</div>
					</div>
					<div><h2><span style={{ color: 'var(--theme-company)' }}>Nuestra</span> Ubicación</h2></div>
				</div>
				<div className='view-ubication'>
					<div className='location-information'>
						<div>
							<div className='head-location-information'>
								<LocationIcon color='#e50027' main_css={{ width: '30px' }} />
								<span style={{ width: '100%', border: '3px solid var(--theme-company)' }}></span>
								<h2>{localizacion}</h2>
							</div>

							<div className='location-schedule'>
								<h2>HORARIO DE ATENCIÓN</h2>
								<div className='back-azul' style={{ backgroundColor: 'var(--theme-company)' }}>
									<span>Horario Continuo</span>
								</div>
								<h3 style={{ cursor: "pointer" }} onClick={openDaysModal}>
									{dia_inicio} a {dia_Fin}
								</h3>
								<h3 style={{ cursor: "pointer" }} onClick={openWeekScheduleModal}>{rango_hora || 'No definido'}</h3>
								<div className='clockContainer'>
									<div className="clock" style={{ backgroundColor: 'var(--theme-company)' }}>
										<div className="face"></div>
										<div className="hour hand"></div>
										<div className="minute hand"></div>
										<div className="cover"></div>
										<div className="second-bulb"></div>
										<div className="second hand"></div>
										<div className="number">8</div>
										<div className="number">6</div>
									</div>
								</div>
								{isEditingSaturday ? (
									<div style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}>
										<TextField
											variant="outlined"
											size="small"
											value={tempSaturdayText}
											onChange={(e) => setTempSaturdayText(validateDays(e.target.value))}
										/>
										<Button variant="contained" onClick={handleSaveSaturdayText}>
											Guardar
										</Button>
										<Button variant="outlined" onClick={handleCancelSaturdayText}>
											Cancelar
										</Button>
									</div>
								) : (
									<h3 style={{ cursor: "pointer" }} onClick={handleSaturdayClick}>
										{particular_dia || 'No definido'}
									</h3>
								)}
								<h3 style={{ cursor: "pointer" }} onClick={openSaturdayScheduleModal}>
									{particular_hora || 'No definido'}
								</h3>
							</div>
							<span style={{ width: '100%', border: '3px solid var(--theme-company)', marginTop: '1rem' }}></span>
						</div>


						<div>
							<MapContainer center={[
								latitud,
								longitud
							]} zoom={16} style={{ width: '90%', height: '80%' }}>
								<TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
								<ChangeMapView coords={[
									latitud,
									longitud
								]} />

								{/* Marker en la posición actual */}
								<Marker position={[
									latitud,
									longitud
								]} icon={customIcon}>
									<Popup>Tu ubicación seleccionada</Popup>
								</Marker>

								{/* Manejador del click en el mapa */}
								<MapClickHandler
									onMapClick={(latlng) => {
										setTempLat(latlng.lat);
										setTempLng(latlng.lng);
										setOpenMapModal(true); // ✅ Solo abre el modal, no mueve el marcador
									}}
								/>
							</MapContainer>
						</div>
					</div>

					<div className='cover-ubication'>
						<div style={{ backgroundColor: 'var(--theme-company)' }}> </div>
						{
							//coverImg ARREGLAR
						}
						<img src={returnFullURL(view3?.img_url ?? null, "picture")} alt="ubicacion" />
					</div>
				</div>
			</div>

			<div className="mobile-ubicacion-container">
				<div className="mobile-title">
					<div className="mobile-header">
						<div className='back-jhimbo'><h3 style={{ color: 'var(--theme-company)' }}>{company_name ?? "Dato invalido"}</h3></div>

						<SelectBranchs color={'var(--theme-main)'} />
					</div>
					<h2><span style={{ color: 'var(--theme-company)' }}>Nuestra Ubicación</span></h2>
				</div>

				<div className="mobile-location">
					<img src={maps_rojo} alt="map" style={{ height: '24px', width: '28px' }} />
					<h2 style={{ color: '#fff', fontSize: '16px', margin: 0 }}>
						{localizacion}
					</h2>
				</div>

				<div className="mobile-schedule">
					<h2>HORARIO DE ATENCIÓN</h2>
					<div className='back-azul' style={{ backgroundColor: 'var(--theme-company)' }}>
						<span>Horario Continuo</span>
					</div>
					<h3 style={{ cursor: "pointer" }} onClick={openDaysModal}>
						{dia_inicio} a {dia_Fin}
					</h3>
					<h3 style={{ cursor: "pointer" }} onClick={openWeekScheduleModal}>{rango_hora || 'No definido'}</h3>
					<div className='clockContainer'>
						<div className="clock" style={{ backgroundColor: 'var(--theme-company)' }}>
							<div className="face"></div>
							<div className="hour hand"></div>
							<div className="minute hand"></div>
							<div className="cover"></div>
							<div className="second-bulb"></div>
							<div className="second hand"></div>
							<div className="number">8</div>
							<div className="number">6</div>
						</div>
					</div>
					{isEditingSaturday ? (
						<div style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}>
							<TextField
								variant="outlined"
								size="small"
								value={tempSaturdayText}
								onChange={(e) => setTempSaturdayText(validateDays(e.target.value))}
							/>
							<Button variant="contained" onClick={handleSaveSaturdayText}>
								Guardar
							</Button>
							<Button variant="outlined" onClick={handleCancelSaturdayText}>
								Cancelar
							</Button>
						</div>
					) : (
						<h3 style={{ cursor: "pointer" }} onClick={handleSaturdayClick}>
							{particular_dia || 'No definido'}
						</h3>
					)}
					<h3 style={{ cursor: "pointer" }} onClick={openSaturdayScheduleModal}>
						{particular_hora || 'No definido'}
					</h3>
				</div>

				<div className="mobile-map">
					<div>
						<MapContainer center={[
							latitud,
							longitud
						]} zoom={16} style={{ width: '95%', height: '45vh', zIndex: 1 }}>
							<TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
							<ChangeMapView coords={[
								latitud,
								longitud
							]} />

							{/* Marker en la posición actual */}
							<Marker position={[
								latitud,
								longitud
							]} icon={customIcon}>
								<Popup>Tu ubicación seleccionada</Popup>
							</Marker>

							{/* Manejador del click en el mapa */}
							<MapClickHandler
								onMapClick={(latlng) => {
									setTempLat(latlng.lat);
									setTempLng(latlng.lng);
									setOpenMapModal(true); // ✅ Solo abre el modal, no mueve el marcador
								}}
							/>
						</MapContainer>
					</div>
				</div>

				<img src={ubicacion_jhimbop}
					alt="ubicacion"
					style={{ width: '100%', borderRadius: '8px' }}
					className={`jhimbo-pic`} />
			</div >

			<Dialog open={showDaysModal} onClose={handleCancelDays}>
				<DialogTitle>Editar Días</DialogTitle>
				<DialogContent dividers>
					<div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
						<Select value={tempDaysRangeStart} onChange={(e) => setTempDaysRangeStart(validateDays(e.target.value))}>
							{DAYS.map((day) => (
								<MenuItem key={day} value={day}>
									{day}
								</MenuItem>
							))}
						</Select>
						<Select value={tempDaysRangeEnd} onChange={(e) => setTempDaysRangeEnd(validateDays(e.target.value))}>
							{DAYS.map((day) => (
								<MenuItem key={day} value={day}>
									{day}
								</MenuItem>
							))}
						</Select>
					</div>
				</DialogContent>
				<DialogActions>
					<Button variant="outlined" onClick={handleCancelDays}>
						Cancelar
					</Button>
					<Button variant="contained" onClick={handleSaveDays}>
						Guardar
					</Button>
				</DialogActions>
			</Dialog>

			{/* (3) Modal para horario Lunes-Viernes */}
			<Dialog open={showWeekScheduleModal} onClose={handleCancelWeekSchedule}>
				<DialogTitle>Editar Horario</DialogTitle>
				<DialogContent dividers>
					<TextField
						autoFocus
						fullWidth
						margin="dense"
						variant="outlined"
						label="Horario"
						value={tempWeekSchedule}
						onChange={(e) => setTempWeekSchedule(e.target.value)}
						placeholder="Ej: 8:00am - 18:00pm"
					/>
				</DialogContent>
				<DialogActions>
					<Button variant="outlined" onClick={handleCancelWeekSchedule}>
						Cancelar
					</Button>
					<Button variant="contained" onClick={handleSaveWeekSchedule}>
						Guardar
					</Button>
				</DialogActions>
			</Dialog>

			{/* (4) Modal para horario sábados */}
			<Dialog open={showSaturdayScheduleModal} onClose={handleCancelSaturdaySchedule}>
				<DialogTitle>Editar Horario (Sábados)</DialogTitle>
				<DialogContent dividers>
					<TextField
						autoFocus
						fullWidth
						margin="dense"
						variant="outlined"
						label="Horario"
						value={tempSaturdaySchedule}
						onChange={(e) => setTempSaturdaySchedule(e.target.value)}
						placeholder="Ej: 8:00am - 16:00pm"
					/>
				</DialogContent>
				<DialogActions>
					<Button variant="outlined" onClick={handleCancelSaturdaySchedule}>
						Cancelar
					</Button>
					<Button variant="contained" onClick={handleSaveSaturdaySchedule}>
						Guardar
					</Button>
				</DialogActions>
			</Dialog>

			{/* (5) Modal para editar lat/lng */}
			<Dialog open={openMapModal} onClose={() => setOpenMapModal(false)}>
				<DialogTitle>Editar Ubicación</DialogTitle>

				<form
					onSubmit={(e) => {
						updateCoodenadas(e);
					}}>
					<DialogContent>
						<TextField
							label="Latitud"
							type="number"
							fullWidth
							value={tempLat}
							onChange={(e) => setTempLat(e.target.value)}
							sx={{ mb: 2 }}
						/>
						<TextField
							label="Longitud"
							type="number"
							fullWidth
							value={tempLng}
							onChange={(e) => setTempLng(e.target.value)}
						/>
					</DialogContent>

					<DialogActions>
						<Button variant="outlined" onClick={() => setOpenMapModal(false)}>
							Cancelar
						</Button>
						<Button variant="contained" type="submit">
							Guardar
						</Button>
					</DialogActions>
				</form>
			</Dialog>
		</>
	)
};
